import { trunkrs } from '../index'

export const invalidateAuth = () =>
  trunkrs.Auth().invalidate()
